export const sameComponentHookCriteria = (_, transition) => {
  var _from$data, _to$data;
  const from = transition == null ? void 0 : transition.from();
  const to = transition == null ? void 0 : transition.to();
  const fromComponent = from == null || (_from$data = from.data) == null ? void 0 : _from$data.sectionId;
  const toComponent = to == null || (_to$data = to.data) == null ? void 0 : _to$data.sectionId;
  if (!fromComponent) {
    return true;
  }
  return fromComponent === toComponent;
};
export const anotherComponentHookCriteria = (_, transition) => {
  var _from$data2, _to$data2;
  const from = transition == null ? void 0 : transition.from();
  const to = transition == null ? void 0 : transition.to();
  const fromComponent = from == null || (_from$data2 = from.data) == null ? void 0 : _from$data2.sectionId;
  const toComponent = to == null || (_to$data2 = to.data) == null ? void 0 : _to$data2.sectionId;
  if (!toComponent) {
    return false;
  }
  return fromComponent !== toComponent;
};
//# sourceMappingURL=policies.js.map